import { LogLevel, getLogger } from '@ori/checkout-utils';
import type { FC, PropsWithChildren } from 'react';

import { APP_NAME } from '../constants';
import { WizardProvider } from '../contexts';
import { useSubscriptionLogic } from '../hooks/useSubscriptionLogic';

const logDebug = getLogger(APP_NAME, LogLevel.Debug);

export const WizardContainer: FC<PropsWithChildren> = ({ children }) => {
  const {
    open,
    customerType,
    wizardType,
    productCode,
    handleClose,
    handleCloseFeedback,
    handleOpenFeedback,
    isFeedbackOpen,
    key,
    handleSave,
    handleError,
  } = useSubscriptionLogic();

  logDebug('WizardContainer ', wizardType, ' | Product code: ', productCode, ' | key: ', key);

  return (
    <WizardProvider
      value={{
        open,
        wizardType,
        customerType,
        onClose: handleClose,
        onError: handleError,
        onSave: handleSave,
        handleCloseFeedback,
        handleOpenFeedback,
        isFeedbackOpen,
        productCode,
        id: key,
      }}
    >
      {children}
    </WizardProvider>
  );
};
